import type { AmmoProductFillResult } from '../../app/api/agent'
import type { AmmoProductFormValues, CartridgeSpecFormValues } from '../../app/models/ammo'
import { normalizeAmmoType, normalizeBulletType } from './ammoSubmitConstants'

export type ApplyAmmoProductFillResult = {
  specForm: CartridgeSpecFormValues
  matchedCartridgeSpecId: string | null
  ammoForm: Partial<AmmoProductFormValues>
}

export function applyAmmoProductFill (
  result: AmmoProductFillResult,
  currentSpec: CartridgeSpecFormValues,
  currentAmmo: AmmoProductFormValues
): ApplyAmmoProductFillResult {
  const specForm: CartridgeSpecFormValues = {
    name: result.spec.name?.trim() || currentSpec.name,
    shortName: result.spec.shortName?.trim() || currentSpec.shortName,
    caliber: result.spec.caliber?.trim() || currentSpec.caliber,
    type: normalizeAmmoType(result.spec.type ?? currentSpec.type)
  }

  const ammoForm: Partial<AmmoProductFormValues> = {
    brand: result.product.brand?.trim() || currentAmmo.brand,
    name: result.product.name?.trim() || currentAmmo.name,
    grainWeight: result.product.grainWeight ?? currentAmmo.grainWeight,
    bulletType: normalizeBulletType(result.product.bulletType ?? currentAmmo.bulletType)
  }

  return {
    specForm,
    matchedCartridgeSpecId: result.matchedCartridgeSpecId,
    ammoForm
  }
}
